<template>
  <div class="item">
    <label class="switch">
      <input type="checkbox" 
        :checked="displayValue" 
        @click="changeValue();$emit('toggle-switch', {code, name, dbTable, mutation, type})" />
      <span class="slider round"></span>
    </label>
    <span class="content" :class="{gray: !displayValue}">{{name}}</span>
  </div>
</template>
<script>
import axios from "axios";

export default {
  props: {
    code: String,
    name: String,
    value: Boolean,
    dbTable: String,
    revert: {
      type: Boolean,
      default: false
    }
  },
  data: function() {
    return {
      mutation: false,
      type: 'boolean'
    }
  },
  computed: {
    displayValue() {
      return this.revert ? !this.mutation : this.mutation;
    }
  },
  mounted() {
    this.mutation = this.value;
  },
  methods: {
    changeValue() {
      this.mutation = !this.mutation;
    }
  },
  watch: {
    value: function(newVal, oldVal) {
      this.mutation = newVal;
    }
  }
};
</script>
<style scoped src="../../../src/assets/css/shop-console.css"></style>